import { Grid, Skeleton } from "@mui/material";
import React from "react";

const TreeSkeleton = () => {
  return (
    <Grid
      container
      sx={{ marginTop: "20px", paddingX: "1rem" }}
      flexDirection={"column"}
      gap={1}
    >
      {[...Array(7)].map((index) => (
        <Skeleton width={250} height={50} key={index} />
      ))}
    </Grid>
  );
};

export default TreeSkeleton;
